<app-news-link [news]="newsPost" [showWithoutLink]="isDetailView">
  <div class="news-list-item__header">
    <img *ngIf="creatorLogoUrl"
         [src]="creatorLogoUrl"
         alt="News list item creator img">
    <div class="news-list-item__header-text">
      <a *ngIf="teamLink"
         [href]="teamLink"
         class="news-list-item__header-link"
         (click)="onCreatorNameClick($event)">
        <h3>{{ newsCreatorName }}</h3>
      </a>
      <h3 *ngIf="!teamLink">{{ newsCreatorName }}</h3>
      <div class="news-list-item__sub-header">
        <mat-icon>schedule</mat-icon>
        <span [matTooltip]="dateTime">{{ timeString }}</span>
      </div>
    </div>
    <button *ngIf="!isTeamPage && !userIsFollowingTeam && isPostedByTeam"
            mat-icon-button color="primary" matTooltip="Folgen" matTooltipPosition="above"
            (click)="onFollowTeam($event)">
      <mat-icon>favorite_border</mat-icon>
    </button>
    <button mat-icon-button matTooltip="Teilen" matTooltipPosition="above" color="primary"
            (click)="$event.stopPropagation(); $event.preventDefault()"
            [matMenuTriggerFor]="shareMenu">
      <mat-icon>share</mat-icon>
    </button>
    <mat-menu #shareMenu xPosition="before">
      <app-news-sharing-buttons style="padding: 8px 16px; display: block"
                                [smallScreenSize]="isSmall"
                                [entityId]="newsPost._id"
                                [sharingMenu]="true"></app-news-sharing-buttons>
    </mat-menu>
  </div>
  <lib-image-carousel
    #imageCarouselComponent
    *ngIf="hasImages || hasVideo"
    (imageClick)="onImageClick($event)"
    (imageChange)="onImageChange()"
    [preloadFirstImage]="preloadFirstImage"
    [firstImageAsVideoPreview]="!isDetailView"
    [user]="userService.currentUser"
    [lazyLoadImages]="lazyLoadImages"
    [showAds]="showAds"
    [youtubeVideo]="newsPost.media?.videoURL"
    [videos]="newsPost.videos_native"
    [autoStartVideo]="isDetailView && hasVideo"
    [images]="images"
    [paywall]="isDetailView"
    [trackingInfo]="trackingInfo">
  </lib-image-carousel>
  <div class="news-list-item__content"
       [class.has-video]="hasVideo"
       [class.has-images]="hasImages">
    <lib-chip-list *ngIf="tags.length" [chips]="tags"></lib-chip-list>
    <div class="news-list-item__inner"
         (click)="onImageClick()"
         [class.clickable]="!isDetailView">
      <h4 *ngIf="newsPost.pretitle" class="subtitle">{{ newsPost.pretitle }}</h4>
      <h1 *ngIf="isDetailView" class="title margin-bottom" [class.detail]="isDetailView">{{ newsPost.title }}</h1>
      <h3 *ngIf="!isDetailView" class="title margin-bottom" [class.detail]="isDetailView">{{ newsPost.title }}</h3>
      <div *ngIf="isDetailView" class="news-list-item__author">
        <mat-icon>person</mat-icon>
        {{ newsPost.author.name }}
      </div>
      <lib-ad *ngIf="showAds && showTopAd" class="my-1"></lib-ad>
      <button *ngIf="hasPreviewButton && !isDetailView"
              mat-flat-button color="accent" class="news-list-item__voting-button">
        {{ newsPost.info.button_text }}
      </button>
      <lib-news-text
        *ngIf="!hasPreviewButton || isDetailView"
        id="news-list-item__text"
        class="news-list-item__text"
        appDynamicComponentEmbed
        [dynamicEmbedsActive]="isDetailView"
        [text]="text"
        [loadEmbeds]="consentService.hasAccepted()"
        (textRender)="textRender.emit($event)"
      ></lib-news-text>
      <a class="clickable news-list-item__enter"
         *ngIf="!isDetailView && text.length > maxPreviewLength && !hasPreviewButton">weiter</a>
      <ng-content *ngIf="isDetailView" select="[detailViewExtraContent]"></ng-content>
      <a *ngIf="isDetailView && isImported()" mat-stroked-button target="_blank"
         class="news-list-item__sm-button" [href]="newsPost?.external_link">
        auf {{ socialMediaType }} ansehen
      </a>
    </div>
  </div>
</app-news-link>

